/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import React from 'react';

import { ZOOM_STYLES } from '../../../constants/CommonStylesConstants';
import { getUITA } from '../../../utils/commonUtils';

const useStyles = makeStyles(ZOOM_STYLES);

function SSEditorZoom({
  className,
  dataObject,
  inTable,
  inFieldGroup,
  isHiddenLabel,
  uniqueIdentifier,
}) {
  const classes = useStyles();
  const isInTable = inTable || (inFieldGroup && isHiddenLabel);

  return (
    <>
      <span
        className={classNames(
          classes.root,
          className,
          isInTable ? classes.inTable : '',
          classes.zoomEditMode
        )}
        ui-ta={getUITA('FormCtrl', 'SSZoom', dataObject, uniqueIdentifier)}
      >
        <div>
          <Search className={classes.searchIcon} />
        </div>
      </span>
    </>
  );
}

export default SSEditorZoom;
